import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { Vehicle } from '@fc-core';
import { AttachmentModel } from '@fc-vehicles/service/attachment-model';
import { CoreGroups } from '@fc-vehicles/components/vehicle-group-colors/core.groups';
import { ImageLoaderModule } from '@fc-shared/ui/image-loader/image-loader.module';
import { VehicleGroupColorsModule } from '@fc-vehicles/components/vehicle-group-colors/vehicle-group-colors.module';

@Component({
  selector: 'fc-vehicle-small-item',
  standalone: true,
  imports: [ImageLoaderModule, VehicleGroupColorsModule],
  template: `
    <div
      [class]="
        groups()?.length
          ? 'flex items-center gap-10'
          : 'grid items-center grid-cols-[30px_1fr]'
      "
    >
      <div class="w-20 h-16 shrink-0 overflow-hidden">
        <fc-image-loader
          [photoModels]="vehiclePhoto()"
          [thumbHeight]="16"
          [thumbWidth]="20"
          [notClickable]="true"
          [currentIndex]="0"
        ></fc-image-loader>
      </div>
      <div class="overflow-hidden text-ellipsis whitespace-nowrap">
        {{ vehicle()?.identifier }}
      </div>
      <fc-vehicle-group-colors [groups]="groups()"></fc-vehicle-group-colors>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleSmallItemComponent {
  vehicle = input<Vehicle>();
  groups = input<CoreGroups[]>();

  vehiclePhoto = computed<AttachmentModel[]>(() => {
    const photo = this.vehicle()?.photo;
    return photo ? [photo] : [];
  });
}
